<template>
  <div>
    <v-toolbar
      class="mb-4"
      flat
    >
      <v-btn-toggle
        v-model="open"
        @change="page = 0"
        color="primary"
        mandatory
        group
      >
        <v-btn :value="false">
          すべて
        </v-btn>
        <v-btn :value="true">
          開催中
        </v-btn>
      </v-btn-toggle>

      <v-divider class="mx-2" vertical />

      <v-flex shrink>
        <v-select
          v-model="tag"
          @change="page = 0"
          class="mx-4"
          :items="all_tags.tags"
          clearable
          dense
          label="タグで絞り込む"
          hide-details
          :menu-props="{ closeOnClick: true, closeOnContentClick: true }"
        />
      </v-flex>

      <v-divider class="mx-2" vertical />

      <v-btn-toggle
        v-model="order"
        group
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon value="submit" :disabled="open" @change="page = 0">
              <v-icon color="primary">mdi-file-document</v-icon>
            </v-btn>
          </template>
          <span>提出者数で並び替え</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon value="star" :disabled="open" @change="page = 0">
              <v-icon color="yellow darken-3">mdi-star</v-icon>
            </v-btn>
          </template>
          <span>お気に入りの数で並び替え</span>
        </v-tooltip>
      </v-btn-toggle>

      <v-spacer />

      <v-btn
        icon
        x-large
        :disabled="page == 0"
        @click="page = 0"
      >
        <v-icon>mdi-chevron-double-left</v-icon>
      </v-btn>

      <v-btn
        icon
        x-large
        :disabled="page == 0"
        @click="page -= 1"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      {{ page + 1 }}

      <v-btn
        icon
        x-large
        :disabled="challenges.length < itemsPerPage * (page + 1)"
        @click="page += 1; maxPage = Math.max(maxPage, page)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-toolbar>

<!--
    <v-list
      three-line
    >
      <v-list-item-group>
        <v-subheader>REPORTS</v-subheader>
        <template v-for="item in currentItems">
          <ChallengeListItem :key="item.id" :challenge="item" />
        </template>
      </v-list-item-group>
    </v-list>
-->

    <v-row
      v-if="currentItems.length > 0"
    >
      <v-col
        v-for="item in currentItems"
        :key="item.id"
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="4"
      >
        <ChallengeCard :challenge="item" />
      </v-col>
    </v-row>
    <div v-else>
      データがありません
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"
//import ChallengeListItem from '@/components/ChallengeListItem.vue'
import ChallengeCard from '@/components/ChallengeCard.vue'

export default {
  components: {
    //ChallengeListItem,
    ChallengeCard,
  },
  props: ["query"],
  data: () => ({
    tag: null,
    all_tags: [],
    challenges: [],
    itemsPerPage: 12,
    page: 0,
    maxPage: 0,
    open: false,
    order: null,
  }),
  computed: {
    currentItems: function () {
      return this.challenges.slice(this.itemsPerPage * this.page, this.itemsPerPage * (this.page + 1))
    },
  },
  methods: {
    bind: function () {
      if (this.query)
      {
        let query = this.query

        if (this.tag) {
          query = query.where("tags", "array-contains", this.tag)
        }

        if (this.open) {
          const today = firebase.firestore.Timestamp.now()
          query = query.where("expireAt", ">=", today)
          query = query.orderBy("expireAt", "desc")
          query = query.orderBy("name", "asc")
        } else if (this.order == "submit") {
          query = query.orderBy("submitCount", "desc")
        } else if (this.order == "star") {
          query = query.orderBy("starCount", "desc")
        } else {
          query = query.orderBy("expireAt", "desc")
          query = query.orderBy("name", "asc")
        }

        this.$bind("challenges", query.limit(this.itemsPerPage * (this.maxPage + 1)))
      }
    },
    push: function() {
      let q = {}
      if (this.tag) {
        q['tag'] = this.tag
      }
      if (this.order) {
        q['order'] = this.order
      }
      if (this.page) {
        q['page'] = this.page + 1
      }
      this.$router.push({ path: this.$route.path, query: q }).catch(() => {})
    },
    update_query: function() {
      if (this.$route.query.tag) {
        this.tag = this.$route.query.tag
      } else {
        this.tag = null
      }
      if (this.$route.query.order) {
        this.order = this.$route.query.order
      } else {
        this.order = null
      }
      if (this.$route.query.page) {
        this.page = Math.max(0, parseInt(this.$route.query.page) - 1)
      } else {
        this.page = 0
      }
      this.maxPage = Math.max(this.maxPage, this.page)
    }
  },
  watch: {
    maxPage: function () { this.bind() },
    query: function () { this.page = 0; this.bind() },
    tag: function () { this.push(); this.bind() },
    open: function () { this.bind() },
    order: function () { this.push(); this.bind() },
    page: function () { this.push(); this.bind() },
    '$route': function () { this.update_query() }, // eslint-disable-line
  },
  created() {
    this.update_query()
    this.bind()
    this.$bind("all_tags", db.doc("common/tags"))
  },
};
</script>
